import React, { useEffect, useState } from 'react';
import { Route, Switch, withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Sidebar from 'containers/SideNav/index';
import PatientPage from './routes/single_patient';
import ViewPatientInfo from './routes/patients/basic/view_patient_info'
import AddPatient from './routes/patients/basic/add-patient'
import {
    COLLAPSED_DRAWER,
    FIXED_DRAWER,
} from 'constants/ActionTypes';
import { fetch_user_details } from "actions/user"
import { isIOS, isMobile } from 'react-device-detect';
import asyncComponent from '../util/asyncComponent';
import { Helmet } from "react-helmet";
import { user_sign_out } from 'actions/Auth';
import { deleteDatabase } from 'indexedb';

const meta_tags = [
    { name: "title", content: "Sleepiz" },
    { name: "description", content: "" },
    { name: "keywords", content: "Sleepiz, Digital health startup, Telemedicine sleep, Telemedicine breathing, Sleep medicine, Sleep test at home, apnea, Sleep apnea, Sleep disorders, Sleep diagnosis, Medical Sleep tracker, Sleep analysis, Contactless monitoring, Home monitoring, Remote monitoring, Breathing rate monitor, Respiratory rate, Breathing monitor, Vital signs monitor, Vital signs" },
    { name: "viewport", content: "width=device-width, initial-scale=1" },
    { name: "application-name", content: "Sleepiz" },
    { name: "author", content: "Sleepiz" },
    { name: "publisher", content: "Sleepiz" }
];

const helmet = () => (
    <Helmet meta={meta_tags} />
)

const toTitleCase = (phrase) => {

    return phrase
        .toLowerCase()
        .split(phrase.includes('_') ? '_' : '-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

const winEvents = [
    'load',
    'mousemove',
    'mouseup',
    'mousedown',
    'click',
    'scroll',
    'keydown',
];

const logoutTime = 28800 * 1000;  // 8 * 3600sec * 1000 => milliseconds

const App = (props) => {

    const [show_drawer, set_show_drawer] = useState(true);
    const path_name = props.location.pathname.split("/", 4);

    if (path_name[3]) {
        if (path_name[3].includes('id')) {
            document.title = "Patient Detail - Sleepiz";
        }
        else {
            document.title = toTitleCase(path_name[3]) + " - Sleepiz";
        }
    } else {
        switch (path_name[2]) {
            case "patients":
                document.title = "My Patients - Sleepiz";
                break;
            case "":
                document.title = "Dashboard - Sleepiz";
                break;
            case "view_patient_info":
                document.title = "Patient Information - Sleepiz";
                break;
            default:
                document.title = toTitleCase(path_name[2] ? path_name[2] : "dashboard") + " - Sleepiz";
                break;

        }
    }


    const hide_drawer = () => {
        set_show_drawer(!show_drawer)
    }

    const { match, drawerType,
        // navigationStyle, horizontalNavPosition, is_authenticated, is_authorized,
        user_sign_out } = props;
    const drawerStyle = drawerType.includes(FIXED_DRAWER) ? 'fixed-drawer' : drawerType.includes(COLLAPSED_DRAWER) ? 'collapsible-drawer' : 'mini-drawer';

    //set default height and overflow for iOS mobile Safari 10+ support.
    if (isIOS && isMobile) {
        document.body.classList.add('ios-mobile-view-height')
    }
    else if (document.body.classList.contains('ios-mobile-view-height')) {
        document.body.classList.remove('ios-mobile-view-height')
    }

    useEffect(() => {
        for (let we in winEvents) {
            window.addEventListener(winEvents[we], resetTimeOut);
        }

        setTimeOut();
        return () => {
            destroy();
        }
    }, [])

    let logoutTimeout = null;

    const clearTimeOut = () => {
        if (logoutTimeout) clearTimeout(logoutTimeout);
    }

    const setTimeOut = () => {
        logoutTimeout = setTimeout(logout, logoutTime);
    }

    const resetTimeOut = () => {
        clearTimeOut();
        setTimeOut();
    }

    const logout = () => {
        destroy();
        user_sign_out();
    }

    const destroy = () => {
        clearTimeOut();
        deleteDatabase();

        for (let i in winEvents) {
            window.removeEventListener(winEvents[i], resetTimeOut);
        }
    }

    return (
        <div className={`app-container ${drawerStyle}`}>
            {helmet()}
            {/* <Tour/> */}
            <Sidebar hide_drawer={hide_drawer} show_drawer={show_drawer} user_sign_out={user_sign_out} />
            <div className="app-main-container">
                <main id="app-main-content-wrapper" className="app-main-content-wrapper">
                    <div className="app-main-content">
                        <Switch>
                            {/* <Route path={`${match.url}/patients/id=:id`} component={PatientPage} /> */}
                            <Route exact path={`${match.url}/patients/id=:id`} component={(props) => <PatientPage {...props} />} />
                            <Route exact path={`${match.url}/patients`} component={asyncComponent(() => import('./routes/patients/basic/index'))} />
                            <Route exact path={`${match.url}/patient/id=:id/edit`} component={asyncComponent(() => import('./routes/patients/basic/new_patient'))} />
                            <Route exact path={`${match.url}/device_testing`} component={asyncComponent(() => import('./routes/device_testing/index'))} />
                            {!props.is_annotator && <Route exact path={`${match.url}/new_patient`} component={asyncComponent(() => import('./routes/patients/basic/new_patient'))} />}
                            {<Route exact path={`${match.url}/view_patient_info/id=:id`} component={ViewPatientInfo} />}
                            {!props.is_annotator && <Route exact path={`${match.url}/add-patient`} component={AddPatient} />}
                            <Route exact path={`${match.url}/privacy-policy`} component={asyncComponent(() => import('./routes/extraPages/routes/privacyPolicy/index'))} />
                            <Route exact path={`${match.url}/terms-of-use`} component={asyncComponent(() => import('./routes/extraPages/routes/termsOfUse/index'))} />
                            {!props.is_annotator && <Route exact path={`${match.url}/`} component={asyncComponent(() => import('./routes/dashboard/index'))} />}
                            {props.is_annotator && <Redirect exact from={`${match.url}/`} to={`${match.url}patients`} />}
                            <Route path={`${match.url}/faq`} component={asyncComponent(() => import('./routes/extraPages/routes/faq/index'))} />
                            <Route path={`${match.url}/realtimeDashboard`} component={asyncComponent(() => import('./routes/device_testing/realtime_dashboard'))} />
                            <Route path={`${match.url}/device_config`} component={asyncComponent(() =>import('./routes/device_config/index'))}/>
                            <Route exact path={`${match.url}/datacenter`} component={asyncComponent(() => import('./routes/datacenter/index'))} />
                            <Route component={asyncComponent(() => {
                                set_show_drawer(false)
                                return (import('components/Error404'))
                            })} />
                        </Switch>
                    </div>
                    {/* <Footer/> */}
                </main>
            </div>
        </div>
    );
}


const mapStateToProps = ({ settings, user }) => {
    const { drawerType, navigationStyle, horizontalNavPosition } = settings;
    return {
        drawerType,
        navigationStyle,
        horizontalNavPosition,
        is_authenticated: user.is_authenticated,
        is_annotator: user.is_annotator,
        is_authorized: user.is_authorized,
        first_name: user.user_details.first_name || " "
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetch_user_details: () => dispatch(fetch_user_details()),
        user_sign_out: () => dispatch(user_sign_out()),
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
